import { IAutoCompleteAddress } from '../models/address_auto_complete'
import { BaseUrl } from './base_url_enum'
import Api, { IApiResponse } from './index'
import { IPendingRelationMutation, IRelationMutation } from './types/relation_mutation'

export type IMutationRequestResponse = {
  relationData: IRelationMutation
}

export interface IIbanCheckResponse {
  data: [] | {
    suggestion?: string
  }
  message?: string
}

export const requestRelationMutation = async (
  refKey: string,
  relationNumber: number,
  relationData: IRelationMutation
) => await Api<IMutationRequestResponse>('POST', `intermediary/${refKey}/relation/${relationNumber}/relation-change`, BaseUrl.Request, relationData)

export const ibanCheck = async (
  accountName: string,
  accountNumber: string
) => await Api<IIbanCheckResponse>('POST', 'iban-check', BaseUrl.Request, {
  accountName,
  accountNumber
})

export const addressCheck = async (
  refKey: string,
  relationNumber: number,
  zipCode: string,
  houseNumber: string
) => await Api<IApiResponse<IAutoCompleteAddress>>('POST', `intermediary/${refKey}/relation/${relationNumber}/address-check`, BaseUrl.Request, {
  zipCode,
  houseNumber
})

export const getPendingMutations = async (
  refKey: string,
  relationNumber: number
) => await Api<IApiResponse<IPendingRelationMutation>>('GET', `intermediary/${refKey}/relation/${relationNumber}/active-changes`, BaseUrl.Request)
